import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./NotFoundPage.scss";

function NotFoundPage() {
    const navigate = useNavigate();

    return (
        <div className="nopage"
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                background: "linear-gradient(135deg, #6EE7B7, #3B82F6)",
                color: "#fff",
                textAlign: "center",
                fontFamily: "'Inter', sans-serif",
            }}
        >
            <h1
                style={{
                    fontSize: "4rem",
                    fontWeight: "bold",
                    marginBottom: "1rem",
                }}
            >
                404
            </h1>
            <p
                style={{
                    fontSize: "1.25rem",
                    marginBottom: "2rem",
                }}
            >
                This page could not be found.
            </p>
            <Link
                onClick={() => { navigate("-1"); }}
                style={{
                    padding: "0.75rem 1.5rem",
                    background: "#2563EB",
                    color: "#fff",
                    borderRadius: "0.5rem",
                    textDecoration: "none",
                    fontWeight: "500",
                    fontSize: "1rem",
                    transition: "background 0.3s",
                }}
                onMouseOver={(e) => {
                    e.target.style.background = "#1E40AF";
                }}
                onMouseOut={(e) => {
                    e.target.style.background = "#2563EB";
                }}
            >
                Go to Home
            </Link>
        </div>
    );
};


export default NotFoundPage;
